import Typography from "@mui/material/Typography";
import { FC } from "react";

import { addressToString } from "helpers/addressToString";
import { AddressType, Maybe } from "operations/schema/schema";
import { JobStylesClasses } from "styles/JobStyles";

interface VisitDetailsProps {
  technicianName?: Maybe<string>;
  customerName?: Maybe<string>;
  customerAddress?: Maybe<AddressType>;
  machineName?: Maybe<string>;
  machineNo?: Maybe<string>;
  location?: Maybe<string>;
  symptomDescription?: Maybe<string>;
  classes?: JobStylesClasses;
}

export const JobVisitDetails: FC<VisitDetailsProps> = (props) => {
  const {
    technicianName,
    customerName,
    customerAddress,
    machineName,
    machineNo,
    location,
    symptomDescription,
    classes,
  } = props;

  const addressString = addressToString(customerAddress);

  return (
    <>
      {technicianName && (
        <Typography variant="body1">
          <span>{technicianName}</span>
        </Typography>
      )}
      {customerName && (
        <Typography variant="body1">
          <span>{customerName}</span>
        </Typography>
      )}
      {customerAddress && (
        <Typography variant="body2" color="secondary" className="truncated">
          {addressString}
        </Typography>
      )}
      {machineName && <Typography variant="body1">{machineName}</Typography>}
      {machineNo && (
        <Typography variant="body2" color="secondary">
          {machineNo}
        </Typography>
      )}
      {location && (
        <Typography variant="body2" color="secondary" className={classes?.paragraph}>
          {location}
        </Typography>
      )}
      {symptomDescription && (
        <Typography
          variant="body2"
          color="secondary"
          className={`${classes?.ellipsis} ${classes?.paragraph} truncated`}
        >
          {symptomDescription}
        </Typography>
      )}
    </>
  );
};
